import React, { useEffect, useState } from "react";
import { styled } from '@mui/system';

import { Button } from 'primereact/button';

import 'primeflex/primeflex.css';
import 'primeicons/primeicons.css';
import { PrimeIcons } from 'primereact/api';
import 'primereact/resources/themes/lara-light-indigo/theme.css'; // theme
import 'primereact/resources/primereact.css';

import "../../styles/theme/aistheme.css";
import "../../styles/theme/sharedThemeOverride.css";
import { MainViewInstruction, changeMainView } from "../../globals/observables/main/mainViewObservable";
import MenuPresenter from "../menu/menuPresenter";
import { MenuBlocksContext } from "../../globals/context/menuBlocksContext";
import { DefaultMenuBlocks, MenuBlockItemCollection } from "../../globals/data/menuData/menuData";
import PagesPresenter from "../pages/pagesPresenter";



const GeneralButtonStyle = {
    display: "flex",
    flexDirection: "row",
    flexGrow: 1,
    color: "black",
    height: "35px",
    marginTop: "auto",
    marginBottom: "auto",
    width: "35px",
    backgroundColor: "gray",
    maxHeight: "35px !Important",
    maxWidth: "35px  !Important",
    minHeight: "35px !Important",
    minWidth: "35px  !Important",
    padding: "0px"
  };
  
  
  const WrapperContainer = styled("div")(
    ({ theme }) => `
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    background-color: #595959;
    flex-basis: 100%;
    `
  );


  
  const HeaderContainer = styled("div")(
    ({ theme }) => `
    display: flex;
    flex-direction: row;
    flex-grow: 1;
    background-color: lightblue;

    
    min-height:100px;
    max-height:100px;

    margin-left:0px;
    margin-right:0px;
    margin-top:auto;
    margin-bottom:auto;
    
    `
  );


  const BodyContainer = styled("div")(
    ({ theme }) => `
    display: flex;
    flex-direction: row;
    flex-grow: 1;
    background-color: lightgreen;

    
    
    `
  );


  
  const MenuContainer = styled("div")(
    ({ theme }) => `
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    background-color: lightgray;

    
    min-width:100px;
    max-width:300px;

    // margin-left:auto;
    // margin-right:auto;
    // margin-top:auto;
    // margin-bottom:auto;
    
    `
  );

  
  
  const PresenterContainer = styled("div")(
    ({ theme }) => `
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    background-color: crimson;

    
    // min-height:100px;

    // margin-left:auto;
    // margin-right:auto;
    // margin-top:auto;
    // margin-bottom:auto;
    
    `
  );


  
  const HeadingContainer = styled("div")(
    ({ theme }) => `
    display: flex;
    flex-direction: row;
    flex-grow: 1;
    //background-color: crimson;

    
    

    margin-left:20px;
    margin-right:auto;
    margin-top:auto;
    margin-bottom:auto;
    
    `
  );



  const HeadingLabelContainer = styled("div")(
    ({ theme }) => `
    color: #FFFFFF;
    
    margin-top: 0px;
    margin-bottom: auto;
    margin-left: auto;
    margin-right: auto;
    display: flex;
    flex-grow: 1;
    justify-content: flex-start;
    align-items: center;
  
    font-family: 'poppins';
    font-weight: 400;
    font-size: calc(28px + (30 - 28) * ((100vw - 1366px) / (2560 - 1366)));
  
  
    `
  );
  
  
  



interface HeaderProps{

}


function LandingPresenter(props:HeaderProps){

    //NOTE:
    //We add new menu items directly in the menuData file found in globals=>data=>menuData=>menuData.tsx
    //The presenter


    const [menuBlocks, setMenuBlocks] = useState<MenuBlockItemCollection>({} as MenuBlockItemCollection);

    useEffect(()=>{
        GenerateMenuData();
    },[])

    const GenerateMenuData = ()=>{
        setMenuBlocks(DefaultMenuBlocks);
    }



    return (
        <MenuBlocksContext.Provider value={menuBlocks}>
        <WrapperContainer id="auth presenter WrapperContainer">
            
            <HeaderContainer id="OutterBoxContainer">
                
                <HeadingContainer>
                    <HeadingLabelContainer>
                    AIStudio Admin Portal
                    </HeadingLabelContainer>

                </HeadingContainer>
            </HeaderContainer>


            <BodyContainer id="BodyContainer">
                <MenuContainer id="MenuContainer">
                    <MenuPresenter/>
                </MenuContainer>
                <PresenterContainer id="PresenterContainer">
                    <PagesPresenter/>
                </PresenterContainer>
            </BodyContainer>



        </WrapperContainer>
        </MenuBlocksContext.Provider>
        
    )
}


export default LandingPresenter;